import { call, put, takeLatest } from "redux-saga/effects";
import {
  onGetClientCapping,
  onGetClientCappingError,
  onGetClientCappingSuccess,
} from "../Store/Slices/clientCappingSlice";
import { callClientCappingGetApi } from "../Context/clientCappingApi";

function* GetClientCapping({ payload }) {
  try {
    const getClientCappingResponse = yield call(
      callClientCappingGetApi,
      payload
    );
    if (getClientCappingResponse.httpStatusCode === "200") {
      yield put(
        onGetClientCappingSuccess({
          data: getClientCappingResponse.response,
          message: getClientCappingResponse.errorMessage,
          status_code: getClientCappingResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetClientCappingError({
          data: getClientCappingResponse.response,
          message: getClientCappingResponse.response.message,
          status_code: getClientCappingResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage || "Something went wrong";
    yield put(onGetClientCappingError({ data: [], message, status_code: 400 }));
  }
}
export default function* clientCappingSaga() {
  yield takeLatest(onGetClientCapping.type, GetClientCapping);
}
